import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo } from "react";
import cx from "classnames";
import { MetadataContent } from "@jutro/uiconfig";
import styles from "./AppFloorPlan.module.css";
var AppFloorPlanFooterInternal = function AppFloorPlanFooterInternal(_ref) {
  var _footerProps$componen,
    footerProps = _ref.footerProps,
    componentMap = _ref.componentMap,
    callbackMap = _ref.callbackMap,
    classNameMap = _ref.classNameMap,
    footerClasses = cx(null == footerProps || null === (_footerProps$componen = footerProps.componentProps) || void 0 === _footerProps$componen ? void 0 : _footerProps$componen.className, styles.footer),
    uiProps = {
      content: [_objectSpread(_objectSpread({
        id: "footer",
        component: "Footer"
      }, footerProps), {}, {
        componentProps: _objectSpread(_objectSpread({}, null == footerProps ? void 0 : footerProps.componentProps), {}, {
          className: footerClasses,
          noDeprecationWarnings: ["Footer", "FooterText", "FooterCopyright", "FooterNavBar", "FooterNavLink"]
        })
      })]
    };
  return React.createElement(MetadataContent, {
    uiProps: uiProps,
    resolveComponentMap: componentMap,
    resolveCallbackMap: callbackMap,
    resolveClassNameMap: classNameMap
  });
};
AppFloorPlanFooterInternal.displayName = "AppFloorPlanFooter";
export var AppFloorPlanFooter = memo(AppFloorPlanFooterInternal);
AppFloorPlanFooterInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanFooter"
}, AppFloorPlanFooterInternal.__docgenInfo = {
  componentName: "AppFloorPlanFooter",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanFooter",
  methods: [],
  actualName: "AppFloorPlanFooterInternal"
};